$(document).on("click", ".tabs_main_item", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tabs_main_item').removeClass('active');
$(this).addClass('active');
$('.columns_center_slider_tab').hide();
$('.columns_center_slider_tab[data_tab="'+data_tab+'"]').show();
$('.columns_center_slider_tab[data_tab="'+data_tab+'"] .slick-slider').slick('refresh');
});
$(document).on("click", ".custom_button", function (e) {
    var currentWrapper = jQuery(this).parents('.video_wrapper_custom');
    var currentVideo = currentWrapper.find('video');

    if (jQuery(this).hasClass("active")) {
        currentWrapper.removeClass('video-active');
        jQuery(this).removeClass('active');
        currentVideo.trigger('pause');
    } else {
        // Pause all other videos and reset buttons
        jQuery('.video_wrapper_custom').each(function () {
            var wrapper = jQuery(this);
            var video = wrapper.find('video');
            var button = wrapper.find('.custom_button');

            video.trigger('pause');
            wrapper.removeClass('video-active');
            button.removeClass('active');
        });

        // Play current video
        currentVideo.trigger('play');
        currentWrapper.addClass('video-active');
        jQuery(this).addClass('active');
    }
});


$(document).on("click", ".question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').removeClass('active');
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", ".trigger_js_show_more", function (e) {
$(this).hide();
$(this).next().show();
$('.custom_mobile_non_slider_reviews>div:first-child~*').show();
});
$(document).on("click", ".trigger_js_show_less", function (e) {
$(this).hide();
$(this).prev().show();
$('.custom_mobile_non_slider_reviews>div:first-child~*').hide();
});


$(document).on("click", '.search_trigger_button', function (e) {
var text = $(this).prev().val();
text = text.trim();
text = text.replace(" ", "+");
var link = '/search';
var new_link = link+'?q='+text;
  location.href=new_link;
});


$('.header_custom_search input').keypress(function (e) {
if (e.which == '13') {
 $(this).next().trigger('click');
}});


$(document).on("click", "a[href='#benifits']", function (e) {
  e.preventDefault();
  document.querySelector('#benifits').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
 jQuery('body').addClass('window-os'); 
}
});



$(document).on("click", '.ajax_add_cart', function(e) {
 e.preventDefault(); 
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
var id = jQuery(this).attr('variant_id');
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: id
},
  dataType: 'json', 
 success: function (data) { 
$('cart-drawer').load(location.href + " #CartDrawer");
setTimeout(function() {
$('cart-drawer').removeClass('is-empty').addClass("active");
this_element.removeClass('loading_hk'); 
}, 500);
 } 
 });
  });

